import React from 'react'

const Footer = () => (
  <div id="footer">
    <div className="inner">
      <ul className="copyright">
        <li>&copy; KWS builders</li>
      </ul>
    </div>
  </div>
)

export default Footer
